import { Command } from '../Command';
import { Notification, Toast } from '../UI';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';

const ShowNotificationCommand = Command.extend({
  detail: Notification
}).defaultTo(
  generateDefault({
    action: commandList.SHOW_NOTIFICATION
  })
);

const ShowToastCommand = Command.extend({
  detail: Toast
}).defaultTo(
  generateDefault({
    action: commandList.SHOW_TOAST
  })
);

const ChangeThemeColorCommand = Command.extend({
  detail: {
    content: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.CHANGE_THEME_COLOR
  })
);

// Remote to Client: Inform client that first view has rendered.
const FirstViewDidMountCommand = Command.extend({
  detail: {
    timestamp: Number
  }
}).defaultTo(
  generateDefault({
    action: commandList.FIRST_VIEW_DID_MOUNT
  })
);

export {
  ShowNotificationCommand,
  ShowToastCommand,
  ChangeThemeColorCommand,
  FirstViewDidMountCommand
};



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/commands/UI.js
 **/